module.exports = flarum.core.compat['components/ComposerBody'];